import { useState } from "react";
import { Button } from "antd";
import { Formik, Field, Form } from "formik";
import Modal from "src/components/Common/Modal";
import { AntInput } from "src/components/Common/CreateAntFields/CreateAntFields";
import { extendExpiryValidation } from "./validate";
import { INITIAL_VALUES } from "./constants";

const ExtendExpiryForm = ({
    isModalActive,
    closeModal,
    onSubmit,
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false)

    return (
        <Modal
            modalVisible={isModalActive}
            cancelModal={() => {
                closeModal()
            }}
            width="350px"
            centered
            className="extend-expiry-modal"
        >
            <div className="extend-expiry-modal-content">
                <div className="text-22 semibold w-75 line-1 pb-30 modal-heading">
                    Extend Link Expiry
                </div>
                <Formik
                    initialValues={INITIAL_VALUES}
                    validationSchema={extendExpiryValidation}
                    onSubmit={(values) => {
                        onSubmit(values.extendBy, setIsSubmitting)
                    }}
                    enableReinitialize
                >
                    {({ values, handleSubmit }) => {
                        return (
                            <Form>
                                <div>
                                    <div className="item-box grid mt-14 mb-30">
                                        <div className="item mb-20">
                                            <Field
                                                component={AntInput}
                                                type="number"
                                                value={values.extendBy}
                                                name={"extendBy"}
                                                label={"Extend by hours"}
                                                hasFeedback
                                                onPressEnter={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <Button
                                            disabled={isSubmitting}
                                            className="ant-btn-primary w-full text-16 weight-400 px-40"
                                            onClick={handleSubmit}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </Modal>
    )
}

export default ExtendExpiryForm